export default "deb6ad4570a6b01e.svg"